export default __webpack_public_path__ + "static/logo-65fca01dfcae1b50ef04a2281be0e1ac.svg";